window.AddressValidator = function(options) {
    var defaults = {
        endpoint: '/address/validate',
        returnDataType: 'json',
    };

    function formatValidationErrors(errors) {
        var msg = 'Please complete all required address fields:<ul>';

        $.each(errors, function(key, value) {
            msg += '<li>'+value+'</li>';
        });

        msg += '</ul>';

        return msg;
    }


    this.opts = $.extend({}, defaults, options);


    this.validate = function(address) {
        var that = this;

        return $.get(that.opts.endpoint, address, null, that.opts.returnDataType)
                .fail(function(xhr) {
                    that.xhrFail.call(this, xhr);
                });
    };

    this.xhrFail = function(xhr) {
        this.failMessage = 'There was a problem validating your address. Please double check the address fields.';

        if(xhr.responseJSON !== undefined) {
            if(xhr.responseJSON.errors !== undefined) {
                this.failMessage = formatValidationErrors(xhr.responseJSON.errors);
            } else if(xhr.responseJSON.message !== undefined) {
                this.failMessage = xhr.responseJSON.message;
            }
        }
    };

}